import { Component, OnInit, OnDestroy } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subscription, Subject } from "rxjs";

import { TableFilter } from "@shared/Entities/General/tableFilter.entity";

@Component({
  templateUrl: "./modalServer.component.html",
  styleUrls: ["./modalServer.component.scss"],
})
export class FilterTableModalServer implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  filtro: TableFilter = new TableFilter();

  allSelected;
  filterValue: string;
  columns: any[] = [];

  public onClose: Subject<any>;

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {
    this.onClose = new Subject();
  }

  aplicarFiltro() {
    this.filtro.filterValue = this.filterValue;
    this.filtro.columns = this.columns;
    this.onClose.next(this.filtro);
    this.bsModalRef.hide();
  }

  //COLUMN CONTROLS
  toggleAllSelected() {
    this.columns.forEach((column) => {
      column.selected = !this.allSelected;
    });
    this.setDisplayColumns();
  }
  setDisplayColumns() {
    this.allSelected =
      this.columns.filter((column) => {
        return !column.selected;
      }).length === 0;
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      if (!subscription.closed) subscription.unsubscribe();
    });
  }
}
